import { createAction, props } from '@ngrx/store';

import { UserConfiguration, CalendarConfiguration } from '../_models';

/** init */
export const initFeature = createAction('[User Configuration] Init User Configuration Module');
export const featureInitSuccess = createAction(
  '[User Configuration] State Init Success',
  props<{ userConfiguration: UserConfiguration }>()
);
export const featureInitError = createAction('[User Configuration] State Init Error');
/** save */
export const saveUserConfiguration = createAction('[User Configuration] Save User Configuration');
export const toggleUseFlattenedCalendar = createAction(
  '[User Configuration] Update Calendar Configuration Data Source',
  props<{ useFlattenedCalendar: boolean }>()
);
export const clearState = createAction('[User Configuration] Clear State');
export const saveUserConfigurationSuccess = createAction(
  '[User Configuration] Save User Configuration Success'
);
export const saveUserConfigurationError = createAction(
  '[User Configuration] Save User Configuration Error',
  props<{ message: string }>()
);
/** calendar config */
export const updateViaCalendarConfiguration = createAction(
  '[User Configuration] Update via Calendar Configuration',
  props<{ calendarConfiguration: CalendarConfiguration }>()
);

export const updateCalendarConfiguration = createAction(
  '[User Configuration] Update User Configuration',
  props<{ userConfiguration: UserConfiguration }>()
);
